import { render, staticRenderFns } from "./BubblesPage.vue?vue&type=template&id=36220478&"
import script from "./BubblesPage.vue?vue&type=script&lang=ts&"
export * from "./BubblesPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports